import styled from '@emotion/styled';

export const StyledDesktopContainer = styled('div')`
  display: flex;
  margin-top: 24px;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  & > * {
    width: 50%;
    max-width: 50%;
  }
`;
